import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { MaintenaceEstablishmentChoiceManualEntryProposalsClientRejectValidationSchema } from '../../../../schemas/forwardings/establishmentChoice/manualEntryProposals/maintenanceEstablishmentChoiceManualEntryProposalsClientReject.schema'

interface UseMaintenanceEstablishmentChoiceManualEntryProposalsClientRejectProps {
  proposalId: string
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalsClientRejectProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation<void, AxiosError, MaintenaceEstablishmentChoiceManualEntryProposalsClientRejectValidationSchema>({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalsClientReject'],
    mutationFn: (data) => privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${proposalId}/client_reject`, {
      client_rejected_reason: data.client_rejected_reason
    }),
    ...options as any
  })
}